import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { PieChart } from 'react-chartkick';
import { SprintChooser } from 'src/layout/SprintChooser';
import { BoardyCard } from '../../components/BoardyCard';
import { TaskStatus } from 'src/models/TaskStatus';
import { StatisticTaskTable } from './StatisticTaskTable';
import Main from 'src/layout/Main';
var Statistics = /** @class */ (function (_super) {
    tslib_1.__extends(Statistics, _super);
    function Statistics(props) {
        var _this = _super.call(this, props) || this;
        _this.load = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.taskStore.loadStatistic(this.props.userStore.userId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Statistics.prototype.componentWillMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.load()];
                    case 1:
                        _a.sent();
                        this.props.taskStore.sprintChanged.subscribe(this.load);
                        return [2 /*return*/];
                }
            });
        });
    };
    Statistics.prototype.componentWillUnmount = function () {
        this.props.taskStore.sprintChanged.unsubscribe(this.load);
    };
    Statistics.prototype.render = function () {
        if (!this.props.taskStore.statistic) {
            return null;
        }
        var statistic = this.props.taskStore.statistic;
        var taskChart = statistic.spentByTasks.length === 0
            ? 'Nincs feladat' : React.createElement(PieChart, { data: statistic.taskChartData, colors: TaskStatus.getPalette() });
        var projectChart = statistic.spentByTasks.length === 0
            ? 'Nincs feladat' : React.createElement(PieChart, { data: statistic.projectChartData });
        var spentTable = statistic.spentByTasks.length === 0
            ? 'Nincs feladat' : React.createElement(StatisticTaskTable, { tasks: statistic.spentByTasks });
        return (React.createElement(Main, null,
            React.createElement(SprintChooser, null),
            React.createElement("div", { className: "container" },
                React.createElement(BoardyCard, { title: 'H\u00E1tral\u00E9v\u0151 feladatok', children: statistic.todo + ' db' }),
                React.createElement(BoardyCard, { title: 'Elk\u00E9sz\u00FClt feladatok', children: statistic.finished + ' db' }),
                React.createElement(BoardyCard, { title: 'Tervezett id\u0151', children: statistic.timePlanned + ' óra' }),
                React.createElement(BoardyCard, { title: 'Elt\u00F6lt\u00F6tt id\u0151', children: statistic.timeSpent + ' óra' }),
                React.createElement(BoardyCard, { title: 'R\u00E1ford\u00EDt\u00E1s', children: spentTable }),
                React.createElement(BoardyCard, { title: 'Feladatok', children: taskChart }),
                React.createElement(BoardyCard, { title: 'Projektek', children: projectChart }))));
    };
    Statistics = tslib_1.__decorate([
        inject('userStore', 'taskStore'),
        observer
    ], Statistics);
    return Statistics;
}(React.Component));
export { Statistics };



//////////////////
// WEBPACK FOOTER
// ./src/pages/statistics/Statistics.tsx
// module id = 794
// module chunks = 0